/**
 * 指定URLへ遷移
 * @param string url URL
 * @return void
 */
export var jumpUrl = function (url) {
    if (url) {
        // urlがセットされていれば、そのurl画面に遷移する
        location.href = url;
    }
};
/**
 * 選択されている言語設定を取得する
 * 取得できない場合は英語の設定を返す
 *
 * @return string 選択言語
 */
export var getLanguage = function () {
    var _a, _b;
    return (_b = (_a = document.getElementById('lang')) === null || _a === void 0 ? void 0 : _a.getAttribute('lang')) !== null && _b !== void 0 ? _b : 'en';
};
/**
 * 変数、定数の値がNULLか確認する
 * @param string url URL
 * @return boolean(NULLまたは空文字の場合: true それ以外の場合: false)
 */
export var nullChecker = function (value) {
    return value !== null && typeof value !== 'undefined' && value !== '';
};
/**
 * 特定のキーを元にバリデーションメッセージを取得する
 *
 * @param key 取得キー
 * @returns バリデーションメッセージ
 */
export var getMessage = function (key, valid_messages) {
    // バリデーションメッセージ取得
    var msg_list = valid_messages === null || valid_messages === void 0 ? void 0 : valid_messages.map(function (valid_message) {
        if (valid_message.key === key) {
            return valid_message.message;
        }
    });
    // 配列内のメッセージを結合した値を返却
    return msg_list.join('\n');
};
